import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-progetto',
  templateUrl: './progetto.component.html',
  styleUrls: ['./progetto.component.scss'],
})
export class ProgettoComponent implements OnInit {
  heroData = {
    title:
      'Un approccio digitale allo studio, <br> per conoscere il mondo e crescere.',
    subtitle:
      "Il lato scientifico-culturale dell'informatica, definito pensiero computazionale, aiuta a sviluppare competenze logiche e capacità di risolvere problemi in modo creativo ed efficiente.",
    imgSrc: '../../../assets/img/floppy_project.png',
    class: 'floppy-projects',
  };
  constructor() {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }
}
